import React, { useState } from 'react';
import { useApp } from '../../AppContext';

interface Props {
  onBack: () => void;
}

export default function ForgotPasswordPanel({ onBack }: Props) {
  const { requestPasswordReset } = useApp();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);
    if (!email.trim()) { setError("Inserisci un indirizzo email."); return; }
    setSending(true);
    try {
      await requestPasswordReset(email.trim());
      setSent(true);
    } catch (e: any) {
      setError(e?.message || 'Errore invio richiesta.');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="space-y-4 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
        </div>
        <h3 className="font-serif text-xl text-forestDark">Controlla la tua email</h3>
        <p className="text-xs text-charcoal/70 leading-relaxed">
          Se l'indirizzo è registrato, riceverai a breve un link per impostare una nuova password.
          Il link è valido per 1 ora.
        </p>
        <button onClick={onBack} className="text-xs uppercase tracking-widest font-bold text-sage hover:text-forest smooth-transition">
          ← Torna al login
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div className="space-y-2 text-center">
        <h3 className="font-serif text-xl text-forestDark">Password dimenticata</h3>
        <p className="text-xs text-charcoal/60">
          Inserisci la tua email: ti invieremo un link per impostare una nuova password.
        </p>
      </div>

      <div className="space-y-2">
        <label className="text-xs font-semibold text-charcoal/70">Email</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') submit(); }}
          autoComplete="email"
          autoFocus
          placeholder="email@esempio.it"
          className="w-full bg-beigeBG border border-forest/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-forest focus:ring-2 focus:ring-forest/15 smooth-transition"
        />
        {error && <p className="text-xs text-rose-700 font-medium">{error}</p>}
      </div>

      <button
        onClick={submit}
        disabled={sending}
        className="btn-shine w-full bg-forest hover:bg-forestDark text-cream py-3 rounded-full text-sm font-semibold smooth-transition hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0"
      >
        {sending ? 'Invio in corso…' : 'Invia link di reset'}
      </button>

      <div className="text-center">
        <button onClick={onBack} className="text-xs uppercase tracking-widest font-bold text-sage hover:text-forest smooth-transition">
          ← Torna al login
        </button>
      </div>
    </div>
  );
}
